import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformWorkerErrorCode {
  WorkerFetchError = 'WorkerFetchError',
  WorkerInitError = 'WorkerInitError',
  FrameInitError = 'FrameInitError',
  PlatformSDKHostInitError = 'PlatformSDKHostInitError',
  AuthEmptyAppDefinitionId = 'AuthEmptyAppDefinitionId',
  AuthEmptyAppAuthInstance = 'AuthEmptyAppAuthInstance',
}

class EditorPlatformError extends BaseError<EditorPlatformWorkerErrorCode> {
  state: Partial<{
    url: string;
    appDefinitionId: string;
  }> = {};

  constructor(message: string, code: EditorPlatformWorkerErrorCode) {
    super(message, code, 'Editor Platform Error');
  }

  withUrl(url: string) {
    this.state = { ...this.state, url };
    return this;
  }

  withAppDefinitionId(appDefinitionId: string) {
    this.state = { ...this.state, appDefinitionId };
    return this;
  }
}

/**
 * This error should be thrown only inside worker
 */
export const createEditorPlatformWorkerError = createErrorBuilder<
  EditorPlatformWorkerErrorCode,
  EditorPlatformError
>(EditorPlatformError);
